const loginprocess ={
    namespaced: true,
 state : {
     process:''
 },
 mutations : {
     getProcess(state, data){
        state.process = data;
     }
 },

actions : {
    setProcess({ commit }, data) {
        commit('getProcess', data);
    },
}
}

export default  loginprocess



// WEBPACK FOOTER //
// ./src/store/modules/login.js